export interface SwitcherComponentConfig {
  checkedValue: unknown;
  uncheckedValue: unknown;
}

export const DEFAULT_CONFIG: SwitcherComponentConfig = {
  checkedValue: true,
  uncheckedValue: false,
};
